import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    control: {
      default: 'bg-grey-30',
      selected: 'bg-brand-1',
      disabled: 'bg-grey-60',
      disabledSelected: 'bg-grey-60'
    },
    label: {
      default: 'c-grey-10',
      disabled: 'c-grey-30',
      shared: 'text-sm'
    },
    wrapper: 'gap-x-2'
  }
} satisfies RecursivePartial<VfConfig['switch']>
